import { render } from "./VueInfinitePager.vue?vue&type=template&id=38dcf1b6"
import script from "./VueInfinitePager.vue?vue&type=script&lang=js"
export * from "./VueInfinitePager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__